import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { messages } from './FollowUpTaskNotes.i18n';

export class FollowUpTaskNotes extends React.Component {
  getTaskName(task) {
    const { taskNames } = this.props;
    const taskNameFound = taskNames.find((taskName) => taskName.key === task.propertyCategoryId);
    if (taskNameFound) {
      return taskNameFound.value;
    }
    return null;
  }
  render() {
    const { appointment, taskNames } = this.props;
    return (
      <div>
        <p>
          <strong><FormattedMessage { ...messages.page.title } /></strong>
        </p>
        <table className="table no-background">
          <tbody>
          {
            appointment ? taskNames.map((taskName, index) => {
              const apptTask = appointment.tasks.find((task) => taskName.key === task.propertyCategoryId);
              if (!apptTask) {
                return null;
              }
              const iconCss = apptTask.isAddressed ? 'icoc icoc-greencheck follow-up-check' : 'fa fa-square-o';
              return (
                <tr key={ index }>
                <td className="status-indicator" style={{ border: 0 }}>
                  <span className={ iconCss } >
                    <span className="square"></span>
                    <span className="checkmark"></span>
                  </span>
                </td>
                <td style={{ border: 0 }}>
                  <span className="data-label">{ taskName.value }</span><br />
                  <span>{ apptTask.taskNote }</span>
                </td>
                </tr>
              );
            }) :
              null
          }
          </tbody>
        </table>
      </div>
    );
  }
}

FollowUpTaskNotes.propTypes = {
  appointment: PropTypes.object,
  taskNames: PropTypes.array,
};

export default connect()(FollowUpTaskNotes);